import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Plan } from 'src/app/models/plan';
import { User } from 'src/app/models/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { PlanService } from 'src/app/services/plan.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-create-plan-dialog',
  templateUrl: './create-plan-dialog.component.html',
  styleUrls: ['./create-plan-dialog.component.scss']
})
export class CreatePlanDialogComponent {
  plan?: Plan;

  user?: User;

  planToCreate: {
    label?: string,
    type?: string,
    maxVolume?: number,
    maxTrademarks?: number,
    maxCases?: number,
    maxCrawlerUrl?: number,
    annualPrice?: number
  } = {
      label: undefined,
      type: undefined,
      maxVolume: undefined,
      maxTrademarks: undefined,
      maxCases: undefined,
      // Optional on purpose: leaving it empty means "no crawler-URL ceiling"
      // (the backend quota check fails open), so it has no entry in `errors`.
      maxCrawlerUrl: undefined,
      annualPrice: undefined
    };

  types: {
    label: string,
    value: string,
    selected: boolean,
    disabled: boolean
  }[] = [
      {
        label: 'PLAN.TYPE_CORPORATE',
        value: 'CORPORATE',
        selected: false,
        disabled: false
      },
      {
        label: 'PLAN.TYPE_LAW_FIRM',
        value: 'LAW_FIRM',
        selected: false,
        disabled: false
      }
    ]

  errors: {
    [key: string]: {
      value: boolean,
      message?: string
    }
  } = {
      label: {
        value: false,
        message: undefined
      },
      type: {
        value: false,
        message: undefined
      },
      maxVolume: {
        value: false,
        message: undefined
      },
      maxTrademarks: {
        value: false,
        message: undefined
      },
      maxCases: {
        value: false,
        message: undefined
      },
      annualPrice: {
        value: false,
        message: undefined
      }
    }


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthenticationService,
    private dialogRef: MatDialogRef<CreatePlanDialogComponent>,
    private planService: PlanService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private utils: UtilsService
  ) {
    this.authService.user.subscribe((user: User | undefined) => {
      this.user = user;
    });
  }

  ngOnInit(): void {
    this.plan = this.data.plan;
    if (this.plan) {
      this.planToCreate = this.plan;
    }
  }

  ngOnDestroy(): void {
  }

  // isDisabled() {
  //   return !this.userToInvite.firstName || !this.userToInvite.lastName || !this.userToInvite.email || !this.userToInvite.role;
  // }

  _hasErrors() {
    this.errors['label'] = {
      value: false,
      message: undefined
    }
    if (!this.planToCreate.label) {
      this.errors['label'].value = true;
      this.errors['label'].message = this.translate.instant('ERRORS.PLAN_LABEL_REQUIRED');
    }

    this.errors['maxVolume'] = {
      value: false,
      message: undefined
    }
    if (!this.planToCreate.maxVolume) {
      this.errors['maxVolume'].value = true;
      this.errors['maxVolume'].message = this.translate.instant('ERRORS.PLAN_MAX_VOLUME_REQUIRED');
    }

    this.errors['maxTrademarks'] = {
      value: false,
      message: undefined
    }
    if (!this.planToCreate.maxTrademarks) {
      this.errors['maxTrademarks'].value = true;
      this.errors['maxTrademarks'].message = this.translate.instant('ERRORS.PLAN_MAX_TRADEMARKS_REQUIRED');
    }

    this.errors['maxCases'] = {
      value: false,
      message: undefined
    }
    if (!this.planToCreate.maxCases && this.planToCreate.type === "LAW_FIRM") {
      this.errors['maxCases'].value = true;
      this.errors['maxCases'].message = this.translate.instant('ERRORS.PLAN_MAX_CASES_REQUIRED');
    }

    this.errors['type'] = {
      value: false,
      message: undefined
    }
    if (!this.planToCreate.type) {
      this.errors['type'].value = true;
      this.errors['type'].message = this.translate.instant('ERRORS.PLAN_TYPE_REQUIRED');
    }

    this.errors['annualPrice'] = {
      value: false,
      message: undefined
    }
    if (this.planToCreate.annualPrice === undefined) {
      this.errors['annualPrice'].value = true;
      this.errors['annualPrice'].message = this.translate.instant('ERRORS.PLAN_ANNUAL_PRICE_REQUIRED');
    }
    return this.errors['label'].value || this.errors['maxVolume'].value || this.errors['maxTrademarks'].value || this.errors['maxCases'].value || this.errors['type'].value || this.errors['annualPrice'].value;
  }

  onPlanTypeChange(event: any) {
    if (event && event.value && event.value.value) {
      this.planToCreate.type = event.value.value;
    }
  }

  onCancel(): void {
    this.dialogRef.close({
      created: false
    });
  }

  async onCreate() {
    if (this._hasErrors()) {
      return
    } else {
      this.dialogRef.close({
        created: true,
        plan: this.planToCreate
      });
    }
  }

  async onUpdate() {
    if (this._hasErrors()) {
      return
    } else {
      this.dialogRef.close({
        updated: true,
        plan: this.planToCreate
      });
    }
  }
} 
